module.exports = __webpack_public_path__ + "static/newark-b16a7aec22695150ade73a72845fa41c.png";